import * as React from "react";
// components
import RadioButton from "common/components/radioButton";
// styles

const styles = require("./changeTopInterestDialogContent.scss");

interface IChangeTopInterestDialogContentProps {
  topInterests: ReadonlyArray<Vingle.UserProfile.IProfileInterestState>;
  selectedInterest: Vingle.UserProfile.IProfileInterestState | null;
  onSelectChange: (interest: Vingle.UserProfile.IProfileInterestState) => void;
}

class ChangeTopInterestDialogContent extends React.PureComponent<
  IChangeTopInterestDialogContentProps
> {
  public render() {
    const { topInterests, selectedInterest, onSelectChange } = this.props;
    const topInterestsNode = topInterests.map(
      (interest: Vingle.UserProfile.IProfileInterestState) => {
        return (
          <li
            className={styles.interestItem}
            key={`topInterestDialog_${
              (interest.data as Vingle.UserProfile.IUserInterest).interest.name
            }`}
          >
            <RadioButton
              onRadioChange={onSelectChange}
              checked={selectedInterest === interest}
              value={interest}
              labelMessage={
                (interest.data as Vingle.UserProfile.IUserInterest).interest.name.split(
                  ":",
                )[0]
              }
            />
          </li>
        );
      },
    );

    return (
      <div>
        <div className={`clearfix`}>
          <ul>{topInterestsNode}</ul>
        </div>
      </div>
    );
  }
}
export default ChangeTopInterestDialogContent;
